import { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import combineResults from "../../../../utils/combineResultsData";
import { faSave, faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment/moment";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { sendResults, getResults } from "../../../../services/CombineService";
import { toast } from "react-toastify";
import { TestsElements } from "./testsElements";
import LoadingSpinner from "../../../../components/LoadingSpinner";

export default function Results({ athlete, eventId }) {
  const apiInstance = useAxiosInstance();
  const [btnLoading, setBtnLoading] = useState(false);
  const saveDataRef = useRef();
  const combineResultsFormRef = useRef();
  const posToast = { position: "top-right" };
  const [loading, setLoading] = useState(false);
  const [verticalJumpOriginal, setVerticalJumpOriginal] = useState(0);

  useEffect(() => {
    setLoading(true);
    combineResultsFormRef.current.reset();
    clearVideoFields();
    getCombineResults(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [athlete, eventId]);

  const toggleClassOnElements = (selector, className, action) => {
    document.querySelectorAll(selector).forEach((element) => {
      action === "add"
        ? element.classList.add(className)
        : element.classList.remove(className);
    });
  };

  const clearInputValues = (selector) =>
    document.querySelectorAll(selector).forEach((input) => (input.value = ""));

  const clearVideoFields = () => {
    toggleClassOnElements("[id^='delete-video-']", "hidden", "add");
    clearInputValues("[id^='videoId-']");
    toggleClassOnElements("[id^='show-video-']", "hidden", "add");
    toggleClassOnElements("[id^='videoToggle-']", "hidden", "remove");
    document.querySelectorAll("[id^='video-player-']").forEach((el) => {
      el.src = "";
    });
  };

  const fetchResultsWithFallback = async () => {
    let results = await getResults(apiInstance, eventId, athlete.userId);

    const shouldRetry = results.length === 0 && saveDataRef?.current;
    if (shouldRetry) {
      saveDataRef.current.click();
      results = await getResults(apiInstance, eventId, athlete.userId);
    }

    return results;
  };

  const handleResults = (response, isFullRefresh) => {
    response.forEach((item) => {
      item.athleteTestDetails.forEach((itemDetails) => {
        const {
          fieldId,
          stage,
          reps,
          stageValue,
          athleteTestDetailId,
          fileUrl,
          videoId,
          auxiliary1,
          auxiliary2,
        } = itemDetails;
        if (isFullRefresh) {
          const testDetailInput = document.getElementById(
            `athleteTestDetailId-${fieldId}`,
          );
          if (athleteTestDetailId && testDetailInput) {
            testDetailInput.value = athleteTestDetailId;
          }

          const input1 = document.getElementById(`item-${fieldId}`);
          const input2 = document.getElementById(`item-1-${fieldId}`);

          if (stage !== "" && reps === 0 && input1) {
            input1.value = stageValue || "";
          } else if (stage === "" && reps > 0 && input1 && input2) {
            input1.value = reps || "";
            input2.value = stageValue || "";
          } else if (stage === "" && reps === 0) {
            if (fieldId !== 9) {
              if (input2) {
                const feet = Math.floor(stageValue / 12);
                const inches = parseFloat(stageValue % 12).toFixed(3);
                input2.value = feet || "";
                input1.value = inches || "";
              } else if (input1) {
                input1.value = stageValue || "";
              }
            }

            if (fieldId === 10) {
            }

            if (fieldId === 9) {
              setVerticalJumpOriginal(stageValue);
              const aux1El = document.getElementById(`item-aux-1-${fieldId}`);
              const aux2El = document.getElementById(`item-aux-2-${fieldId}`);
              const aux3El = document.getElementById(`item-aux-3-${fieldId}`);
              const aux4El = document.getElementById(`item-aux-4-${fieldId}`);
              const totalInches = document.getElementById(`item-${fieldId}`);

              if (aux1El && aux2El && aux3El && aux4El) {
                aux1El.value = Math.floor(auxiliary1 / 12) || "";
                aux2El.value = parseFloat(auxiliary1 % 12).toFixed(3) || "";
                aux3El.value = Math.floor(auxiliary2 / 12) || "";
                aux4El.value = parseFloat(auxiliary2 % 12).toFixed(3) || "";
                totalInches.value = stageValue || "";
              }
            }
          }

          if (fieldId === 6 || fieldId === 3) {
            const aux1El = document.getElementById(`item-aux-1-${fieldId}`);
            if (aux1El) {
              aux1El.value = auxiliary1 ?? "";
            }
          }
        }
        const videoContainer = document.getElementById(
          `video-player-${fieldId}`,
        );
        const toggle = document.getElementById(`videoToggle-${fieldId}`);
        const showVideo = document.getElementById(`show-video-${fieldId}`);
        const videoIdInput = document.getElementById(`videoId-${fieldId}`);

        if (videoContainer && toggle && showVideo && videoIdInput) {
          const hasVideo = fileUrl !== "";
          showVideo.classList.toggle("hidden", !hasVideo);
          showVideo.classList.toggle("flex", hasVideo);
          videoContainer.src = hasVideo ? fileUrl : "";
          videoIdInput.value = hasVideo ? videoId : "";
          toggle.classList.toggle("hidden", hasVideo);
        }
      });
    });
  };

  const getCombineResults = async (isFullRefresh) => {
    try {
      const response = await fetchResultsWithFallback();

      if (response.length > 0) {
        handleResults(response, isFullRefresh);
      } else {
        combineResultsFormRef.current?.reset();
      }
    } catch (error) {
      console.error("Error getting combine results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setBtnLoading(true);
    let data = {
      eventId: eventId,
      userId: athlete.userId,
      combineResults: [],
      testDateUTC: moment().format(),
    };

    combineResults.forEach((itemResult) => {
      itemResult.test.forEach((itemTest) => {
        const idToRead = `item-${itemTest.fieldId}`;
        const idValue = document.getElementById(idToRead).value;
        let stageValue = 0;
        let auxiliary1 = 0;
        let auxiliary2 = 0;

        if (itemTest.name === "stageValue" && itemTest.stageAsField === false) {
          stageValue = parseFloat(idValue).toFixed(3) || 0;
        }
        if (itemTest.stageAsField === true) {
          if (!itemTest.aux) {
            const id2ToRead = `item-1-${itemTest.fieldId}`;
            const id2Value = document.getElementById(id2ToRead).value;
            if (itemTest.name === "stageValue") {
              const ftToIn = id2Value * 12;
              const dataFtIn = parseInt(ftToIn) + parseFloat(idValue);
              stageValue = parseFloat(dataFtIn).toFixed(3) || 0;
            }
            if (itemTest.name === "reps") {
              stageValue = parseFloat(id2Value).toFixed(2) || 0;
            }
          }
        }
        if (itemTest.aux) {
          const aux1 =
            document.getElementById(`item-aux-1-${itemTest.fieldId}`).value ||
            0;
          const aux2 =
            document.getElementById(`item-aux-2-${itemTest.fieldId}`).value ||
            0;
          const aux3 =
            document.getElementById(`item-aux-3-${itemTest.fieldId}`).value ||
            0;
          const aux4 =
            document.getElementById(`item-aux-4-${itemTest.fieldId}`).value ||
            0;
          auxiliary1 = parseInt(aux1) * 12 + parseFloat(aux2);
          auxiliary2 = parseInt(aux3) * 12 + parseFloat(aux4);

          const verticalJump = auxiliary1 - auxiliary2;

          if (isNaN(auxiliary1) && isNaN(auxiliary2)) {
            stageValue = verticalJumpOriginal;
          } else if (auxiliary1 === 0 || auxiliary2 === 0) {
            stageValue = verticalJumpOriginal;
          } else {
            stageValue = Math.abs(verticalJump);
          }
        }
        if (itemTest.subFields?.topSpeed) {
          const input = document.getElementById(
            `item-aux-1-${itemTest.fieldId}`,
          );
          const value = input ? parseFloat(input.value) : 0;
          auxiliary1 = isNaN(value) ? 0 : value;
        }

        const testData = {
          testName: itemResult.name,
          stage: itemTest.stage.toString() || "",
          stageValue: !isNaN(stageValue)
            ? parseFloat(stageValue).toFixed(3)
            : 0,
          reps: itemTest.name === "reps" ? parseInt(idValue) : 0,
          fieldId: itemTest.fieldId,
          uploadDate: moment().format(),
          attemptNumber: itemResult.attempt,
          unitOfMeasurement: itemResult.unit,
          auxiliary1: auxiliary1 || 0,
          auxiliary2: auxiliary2 || 0,
          videoId: itemTest.videoId,
        };
        data.combineResults.push(testData);
      });
    });

    data.combineResults.push({
      testName: "Broad jump",
      stage: "",
      stageValue: "0.000",
      reps: 0,
      fieldId: 12,
      uploadDate: moment().format(),
      attemptNumber: 2,
      unitOfMeasurement: "inches",
      auxiliary1: 0,
      auxiliary2: 0,
      videoId: 1,
    });

    try {
      await sendResults(apiInstance, data);
      getCombineResults(true);
      toast.success("Combine Results saved successfully!", posToast);
    } catch (err) {
      toast.error(
        "Error saving Combine Results. Please check the measurements.",
        posToast,
      );
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="w-[46%] pt-10 h-full z-20 bg-white opacity-60 fixed">
          <LoadingSpinner />
        </div>
      )}
      <form onSubmit={handleSubmit} id="form" ref={combineResultsFormRef}>
        {combineResults?.map((itemResult, indexResult) => (
          <TestsElements
            key={indexResult}
            itemResult={itemResult}
            saveDataRef={saveDataRef}
            setBtnLoading={setBtnLoading}
            callGetCombine={getCombineResults}
          />
        ))}
        <div className="w-auto ">
          {btnLoading ? (
            <button
              type="button"
              className="uppercase h-[40px] px-2 text-white bg-red-300 cursor-not-allowed rounded ml-4 my-auto"
            >
              <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
              Saving Changes
            </button>
          ) : (
            <button
              ref={saveDataRef}
              className="uppercase py-2 px-2 text-white bg-red-500 rounded hover:bg-red-700"
            >
              <FontAwesomeIcon icon={faSave} className="mr-2" />
              Save / Update Changes
            </button>
          )}
        </div>
      </form>
    </>
  );
}
